// Application URL for the Project Wolfpack application
export const APP_URL = "https://pwp.helplinesoftware.com";
